import { render, staticRenderFns } from "./ScannedProductsPerStoreIndicator.vue?vue&type=template&id=4b5e1112"
import script from "./ScannedProductsPerStoreIndicator.vue?vue&type=script&lang=js"
export * from "./ScannedProductsPerStoreIndicator.vue?vue&type=script&lang=js"
import style0 from "./ScannedProductsPerStoreIndicator.vue?vue&type=style&index=0&id=4b5e1112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports